import { gql } from '@apollo/client';

const variantsSpecificationsAndFeatures = {
  GET_VARIANTS_SPECIFICATIONS_AND_FEATURES: gql`
    query GetVariantsSpecificationsAndFeatures($filters: Filters) {
      trimLevelVariants(filters: $filters) {
        variants {
          variant {
            code
            attributes {
              marketingCategory
              name
              modelName
              featureGroups {
                name
                featureItems {
                  name
                  value
                  disclaimer
                }
              }
              specGroups {
                name
                specItems {
                  name
                  value
                  disclaimer
                }
              }
            }
          }
        }
      }
    }
  `,
};

export default variantsSpecificationsAndFeatures;
